module.exports = __webpack_public_path__ + "img/Support-skill-626.01133f4d.png";